function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 4H3H19",
  stroke: "#2E49D1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4H5ZM6.58579 0.58579L7.29289 1.29291L7.29291 1.29289L6.58579 0.58579ZM13.4142 0.58579L12.7071 1.29292L12.7071 1.29293L13.4142 0.58579ZM13 4C13 4.55228 13.4477 5 14 5C14.5523 5 15 4.55228 15 4H13ZM17 4H18C18 3.44772 17.5523 3 17 3V4ZM3.58579 19.4142L4.29293 18.7071L4.29292 18.7071L3.58579 19.4142ZM3 4V3C2.44772 3 2 3.44772 2 4H3ZM7 4V2H5V4H7ZM7 2C7 1.73478 7.10536 1.48043 7.29289 1.29291L5.87869 -0.121326C5.31606 0.441288 5 1.20436 5 2H7ZM7.29291 1.29289C7.48043 1.10536 7.73478 1 8 1V-1C7.20436 -1 6.44129 -0.683936 5.87867 -0.121307L7.29291 1.29289ZM8 1H12V-1H8V1ZM12 1C12.2652 1 12.5195 1.10534 12.7071 1.29292L14.1213 -0.121336C13.5587 -0.683923 12.7956 -1 12 -1V1ZM12.7071 1.29293C12.8946 1.48044 13 1.73477 13 2H15C15 1.20437 14.684 0.441284 14.1213 -0.121345L12.7071 1.29293ZM13 2V4H15V2H13ZM16 4V18H18V4H16ZM16 18C16 18.2652 15.8947 18.5195 15.7071 18.7071L17.1213 20.1213C17.6839 19.5587 18 18.7956 18 18H16ZM15.7071 18.7071C15.5195 18.8947 15.2652 19 15 19V21C15.7956 21 16.5587 20.6839 17.1213 20.1213L15.7071 18.7071ZM15 19H5V21H15V19ZM5 19C4.73477 19 4.48044 18.8946 4.29293 18.7071L2.87865 20.1213C3.44128 20.684 4.20437 21 5 21V19ZM4.29292 18.7071C4.10534 18.5195 4 18.2652 4 18H2C2 18.7956 2.31608 19.5587 2.87866 20.1213L4.29292 18.7071ZM4 18V4H2V18H4ZM3 5H17V3H3V5Z",
  fill: "#2E49D1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9V15",
  stroke: "#2E49D1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9V15",
  stroke: "#2E49D1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f7b4ae77.svg";
export { ForwardRef as ReactComponent };